import { render } from "./DocumentWorkbench.vue?vue&type=template&id=32ad3cfa&scoped=true"
import script from "./DocumentWorkbench.vue?vue&type=script&lang=js"
export * from "./DocumentWorkbench.vue?vue&type=script&lang=js"

import "./DocumentWorkbench.vue?vue&type=style&index=0&id=32ad3cfa&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ad3cfa"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QTabs,QTab});
